module.exports = __webpack_public_path__ + "static/media/Location.778f271d.svg";